/**
 * `window.open` defends against `javascript:` / `data:` URL XSS.
 *
 * The API's `redactUrl` already rejects non-`http(s):` schemes at
 * ingestion (apps/api/src/captureRedaction.ts), but legacy tickets
 * predate that filter and a future regression on the server side
 * shouldn't immediately escalate to stored XSS. `noopener,noreferrer`
 * is NOT enough — those flags don't block `javascript:` from
 * executing in the new tab's context. A protocol allowlist is the
 * only reliable defense.
 */
export function safeOpen(rawUrl: string | undefined | null): void {
  if (!rawUrl) return;
  if (!/^https?:\/\//i.test(rawUrl)) {
    // Silently no-op rather than navigating somewhere unsafe. We don't
    // toast — the link is for power users (Open source URL); a noisy
    // failure on legacy/seed data would be worse than the no-op.
    return;
  }
  window.open(rawUrl, '_blank', 'noopener,noreferrer');
}
